var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid",
  className: "lds-rolling",
  style: {
    backgroundImage: "none",
    backgroundPosition: "initial initial",
    backgroundRepeat: "initial initial"
  }
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  fill: "none",
  "ng-attr-stroke": "{{config.color}}",
  "ng-attr-stroke-width": "{{config.width}}",
  "ng-attr-r": "{{config.radius}}",
  "ng-attr-stroke-dasharray": "{{config.dasharray}}",
  stroke: "#d3cece",
  strokeWidth: 10,
  r: 35,
  strokeDasharray: "164.93361431346415 56.97787143782138"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  calcMode: "linear",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: "1s",
  begin: "0s",
  repeatCount: "indefinite"
}))));
export default __webpack_public_path__ + "static/media/loading.2af9fb25.svg";
export { SvgLoading as ReactComponent };